export default {
  navigationBarTitleText: '详情'
};
